import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Activity, Heart, Users, Phone, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { rehabServicesContent, clinicInfo } from '../mock';

const RehabServices = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-50 to-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-[#000053] mb-6">
              {rehabServicesContent.title}
            </h1>
            <p className="text-xl text-[#36454F] mb-8">
              {rehabServicesContent.subtitle}
            </p>
            <p className="text-lg text-gray-600 mb-8">
              {rehabServicesContent.description}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-4">
              <a href={`tel:${clinicInfo.rehabPhone}`}>
                <Button size="lg" variant="outline" className="border-2 border-[#006D73] text-[#006D73] hover:bg-[#006D73] hover:text-white transition-all">
                  <Phone className="mr-2 h-5 w-5" />
                  Call {clinicInfo.rehabPhone}
                </Button>
              </a>
              <Link to="/book">
                <Button size="lg" className="bg-[#006D73] text-white hover:bg-[#005a5f] transition-all">
                  Book a Session
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {rehabServicesContent.services.map((service) => (
              <Card key={service.id} className="hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border-2 hover:border-[#006D73]">
                <CardHeader>
                  <div className="h-14 w-14 bg-[#006D73] bg-opacity-10 rounded-lg flex items-center justify-center mb-4">
                    {service.id === 'physiotherapy' && <Activity className="h-7 w-7 text-[#006D73]" />}
                    {service.id === 'chiropractic' && <Heart className="h-7 w-7 text-[#006D73]" />}
                    {service.id === 'massage' && <Users className="h-7 w-7 text-[#006D73]" />}
                    {service.id === 'orthotics' && <Activity className="h-7 w-7 text-[#006D73]" />}
                  </div>
                  <CardTitle className="text-2xl text-[#000053]">{service.title}</CardTitle>
                  <CardDescription className="text-gray-600 text-base">{service.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <Link to={service.link}>
                    <Button variant="link" className="text-[#006D73] hover:text-[#005a5f] p-0 h-auto font-semibold text-base">
                      Learn More <ArrowRight className="ml-2 h-5 w-5" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Contact Info */}
          <div className="max-w-3xl mx-auto mt-12">
            <Card className="border-2 border-[#006D73]">
              <CardContent className="p-8">
                <h3 className="text-xl font-bold text-[#000053] mb-6 text-center">Rehabilitation Services Contact</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex items-center space-x-4">
                    <Phone className="h-6 w-6 text-[#006D73] flex-shrink-0" />
                    <div>
                      <p className="text-sm text-gray-600 font-medium">Phone</p>
                      <a href={`tel:${clinicInfo.rehabPhone}`} className="text-[#006D73] hover:underline text-lg font-semibold">
                        {clinicInfo.rehabPhone}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center space-x-4">
                    <Mail className="h-6 w-6 text-[#006D73] flex-shrink-0" />
                    <div>
                      <p className="text-sm text-gray-600 font-medium">Email</p>
                      <a href={`mailto:${clinicInfo.rehabEmail}`} className="text-[#006D73] hover:underline text-lg font-semibold">
                        {clinicInfo.rehabEmail}
                      </a>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#000053]">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              Start Your Recovery Journey Today
            </h2>
            <p className="text-gray-300 mb-8">
              Our integrated team approach ensures you receive comprehensive, coordinated care for optimal results.
            </p>
            <Link to="/book">
              <Button size="lg" className="bg-[#006D73] text-white hover:bg-[#005a5f] transition-all">
                Book Your First Session
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RehabServices;